// src/pages/Login.tsx

import React, { useState, useContext, FormEvent } from 'react';
import { login, fetchProfile } from '../api/auth';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const auth = useContext(AuthContext);
  if (!auth) throw new Error('AuthContext is not available');
  const { setUser } = auth;

  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      // 1) Send credentials and set HTTP-only cookie
      await login(username, password);

      // 2) Retrieve profile using the cookie
      const profile = await fetchProfile();

      // 3) Guard against null (fetchProfile returns null on 401)
      if (!profile) {
        setError('Logged in but failed to fetch profile.');
        return;
      }

      // 4) Update context and redirect
      setUser(profile.username);
      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Login failed');
    }
  };

  const pageStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f7fa',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  };

  const cardStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '360px',
    textAlign: 'center' as const,
  };

  const logoStyle: React.CSSProperties = {
    height: '50px',
    marginBottom: '1rem',
  };

  const headerStyle: React.CSSProperties = {
    fontSize: '1.5rem',
    color: '#000000',
    marginBottom: '1.5rem',
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '0.75rem 0',
    marginBottom: '1rem',
    border: 'none',
    borderBottom: '1px solid #ccc',
    outline: 'none',
    fontSize: '1rem',
  };

  const buttonStyle: React.CSSProperties = {
    width: '100%',
    padding: '0.75rem',
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1.05rem',
    cursor: 'pointer',
  };

  const errorStyle: React.CSSProperties = {
    marginTop: '0.75rem',
    color: '#d9534f',
    fontSize: '0.9rem',
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        {/* Orchard-Rite Logo */}
        <img src="/orlogo_red.png" alt="Orchard-Rite Logo" style={logoStyle} />

        <h2 style={headerStyle}>Market Insights</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={inputStyle}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={inputStyle}
            required
          />
          <button type="submit" style={buttonStyle}>
            Log In
          </button>
          {error && <p style={errorStyle}>{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default Login;
